import {useContext} from "react";
import {ServiceListContext} from "../state/serviceContext";
import {ServiceQuery} from "../queries/ServiceQuery";
import {Item} from "../../marketPlace/queries/Item";

const useServiceFavorite = () => {
    const {dispatch} = useContext(ServiceListContext)

    const addToFavorite = async (id, wishlistId) => {
        dispatch({action: "addToFavorite", payload: id})
         return Item.addToFavorite(id, wishlistId).then( (res) => {console.log(res);return res.data.wishlist_product.id})
            .catch( () => {dispatch({action: "removeFromFavorite", payload: id}); return false; }) // revert action if something goes wrong
    }

    const removeFromFavorite = (id, wishlistId) => {
        dispatch({action: "removeFromFavorite", payload: id})
        return  Item.removeFromFavorite(id, wishlistId).then( () => { return true})
            .catch( () => {dispatch({action: "addToFavorite", payload: id}); return false; })// revert action if something goes wrong
    }

    return {addToFavorite, removeFromFavorite}
}

export {useServiceFavorite}
